import request from "axios";
import moment from "moment";

export const sendFeedback = async (idToken, candidateRef, formData) =>
  request.post(
    `${process.env.REACT_APP_PROFILE_API_URL}/clientDashboard/candidate/${candidateRef}/feedback`,
    formData,
    {
      headers: { Authorization: `Bearer ${idToken}` }
    }
  );

const cookieName = "promptFeedback";
export const checkIfFeedbackCached = () => document.cookie.indexOf(cookieName) >= 0;

export const cacheFeedback = () => {
  const expires = moment()
    .set({ month: moment().month() + 3 })
    .toDate()
    .toUTCString();
  document.cookie = `${cookieName}=false; expires=${expires};`;
};
